<form class="form-signin" [formGroup]="form" (submit)="submit()" >
  <h1 class="h3 mb-3 font-weight-normal">Please sign in</h1>

  <label for="inputEmail" class="sr-only">Email address</label>
  <input type="email" formControlName="email"  id="inputEmail" class="form-control" placeholder="Email address" required autofocus>

  <label for="inputPassword" class="sr-only">Password</label>
  <input type="password" formControlName="password" id="inputPassword" class="form-control" placeholder="Password" required>

  <button class="btn btn-lg btn-primary btn-block" type="submit">Sign in</button>
</form>
